import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

/**
 * Format a date with Day.js.
 *
 * @see https://day.js.org/docs/en/parse/string-format
 */
export default function formatDate(
	date: string | null,
	targetFormat = 'DD/MM/YYYY',
	sourceFormat: string | null = null,
	locale: string | null = null
): string {
	dayjs.extend(utc);
	dayjs.extend(timezone);

	dayjs.locale(locale || 'fr');

	if (null === date || '' === date) {
		return '';
	}

	if ('today' === date) {
		return dayjs().format(targetFormat);
	}

	let dateObject: dayjs.Dayjs = dayjs(date as string);

	if (undefined !== date && null !== date && date.includes('/')) {
		sourceFormat = 'DD/MM/YYYY';
	}

	if (null !== sourceFormat) {
		dateObject = dayjs(date as string, sourceFormat);
	}

	const dateResult: string = dateObject.tz('Europe/Paris').format(targetFormat);

	// Return raw date value if an error occured.
	if ('Invalid Date' === dateResult) {
		return date;
	}

	return dateResult;
}

/** Format a date with time to DD/MM/YYYY HH:mm format */
export function formatDateTime(date: string | null, format = 'DD/MM/YYYY HH:mm'): string {
	return formatDate(date, format);
}
